// Utilidades para detectar dispositivos móviles y características de pantalla
import { useState, useEffect } from 'react';

export const isMobileDevice = () => {
  // Check user agent for mobile indicators
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i;
  const isMobileUA = mobileRegex.test(userAgent.toLowerCase());

  // Check screen size
  const isSmallScreen = window.innerWidth <= 768;

  // Check touch capability
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // Return true if any mobile indicator is present
  return isMobileUA || (isSmallScreen && isTouchDevice);
};

export const isTabletDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const tabletRegex = /ipad|android(?!.*mobile)|tablet/i;

  return tabletRegex.test(userAgent.toLowerCase()) ||
         (window.innerWidth >= 768 && window.innerWidth <= 1024 && 'ontouchstart' in window);
};

export const getScreenType = () => {
  const width = window.innerWidth;

  if (width < 576) return 'mobile-small'; // Phones in portrait
  if (width < 768) return 'mobile-large'; // Phones in landscape, small tablets in portrait
  if (width < 992) return 'tablet';       // Tablets
  if (width < 1200) return 'laptop';      // Small laptops
  return 'desktop';                       // Large screens
};

export const shouldUseMobileInterface = () => {
  // Use mobile interface if:
  // 1. User agent indicates mobile device
  // 2. Screen width is less than 768px (typical mobile breakpoint)
  // 3. Device has touch capability and small screen

  const screenType = getScreenType();
  const isMobile = isMobileDevice();

  // Force mobile interface for phones and small screens
  return isMobile || screenType === 'mobile-small' || screenType === 'mobile-large';
};

export const getOptimalGridColumns = () => {
  const screenType = getScreenType();

  switch (screenType) {
    case 'mobile-small': return 1;
    case 'mobile-large': return 1;
    case 'tablet': return 2;
    case 'laptop': return 3;
    default: return 4;
  }
};

// Hook personalizado para detectar cambios de tamaño de pantalla
export const useScreenSize = () => {
  const [screenType, setScreenType] = useState(getScreenType());
  const [isMobile, setIsMobile] = useState(shouldUseMobileInterface());

  useEffect(() => {
    const handleResize = () => {
      setScreenType(getScreenType());
      setIsMobile(shouldUseMobileInterface());
    };

    window.addEventListener('resize', handleResize);

    // Initial check
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { screenType, isMobile };
};